import React from "react";

import { PageContent, HubCardStack } from "../../components";
import { LineItemsTable } from "../../tables";

import ShippingBar from "./ShippingBar";

const ShippingPageContent = ({ defaultLocation }) => {
  return (
    <PageContent gap="15px" smallPadding>
      <HubCardStack height="100%" gap="15px">
        <ShippingBar />
        <LineItemsTable defaultLocation={defaultLocation} />
      </HubCardStack>
    </PageContent>
  );
};

export default ShippingPageContent;
